module.exports = __webpack_public_path__ + "static/polityka-prywatnosci-604b73cef6acfff9aafe91ed4ed1eec9.pdf";